import { GROUP_AUTH_HEADER_NAME } from "@/constants/axios";
import type { PatientConsent, UUID } from "@/core/types";
import type { AptiRequestConfig } from "@/lib/types/api";
import { getGroupAuthType } from "@/redux/actions/auth";

import { httpAuth } from "../utils/axios";

export const providerRequestsTyped = {
  get_patient_consents: function ({
    params,
    patientId,
  }: {
    params?: Record<string, unknown>;
    patientId: UUID;
  }) {
    const config = {
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      method: "POST",
      params,
      url: `/v1/patient_management/${patientId}/get_latest_consents`,
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<PatientConsent[]>;
  },
};
